/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { GreenhouseAccountCto } from '../../models/greenhouse-account-cto';

export interface GetActiveGreenhouseAccountsAsync$Json$Params {
}

export function getActiveGreenhouseAccountsAsync$Json(http: HttpClient, rootUrl: string, params?: GetActiveGreenhouseAccountsAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<GreenhouseAccountCto>>> {
  const rb = new RequestBuilder(rootUrl, getActiveGreenhouseAccountsAsync$Json.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<GreenhouseAccountCto>>;
    })
  );
}

getActiveGreenhouseAccountsAsync$Json.PATH = '/integrations/greenhouse/companies';
